import type { SWRConfiguration } from 'swr'
import useSWR from 'swr'

import { getUserLists } from '../api/listApi'
import { List } from '../types'

export default function useUserLists(options?: SWRConfiguration) {
  return useSWR<List[], Error>('lists', getUserLists, options)
}
